// import React from "react";
// import { Input } from "../../components/Input/Input";
// import { Textarea } from "../../components/Textarea/Textarea";
// import { useDispatch, useSelector } from "react-redux";
// import { setNewAssistant } from "../../../../store/slices/assistantSlice";
// import styles from "./AssistantFormModule.module.scss";
// import { Select } from "../../ui/Select/Select";

// export const AssistantFormModule = ({ newAssistant }) => {
//   const dispatch = useDispatch();

//   const instructions = useSelector((state) => state?.instruction?.instructions);

//   const selectedTemplate = newAssistant?.selectedTemplate || null;

//   const handleSelectTemplate = (value) => {
//     const updatedAssistant = {
//       ...newAssistant,
//       selectedTemplate: value,
//       settings: {
//         ...newAssistant.settings,
//         instruction: value,
//       },
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const handlerNameAssistant = (value) => {
//     const updatedAssistant = {
//       ...newAssistant,
//       name: value,
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const handlerFirstNameAssistant = (value) => {
//     const updatedAssistant = {
//       ...newAssistant,
//       firstName: value,
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const handlerCompanyDescription = (e) => {
//     const updatedAssistant = {
//       ...newAssistant,
//       companyDescription: e.target.value,
//     };

//     dispatch(setNewAssistant(updatedAssistant));
//   };

//   const options = instructions?.map((item) => ({
//     value: item.instruction,
//     label: item.category,
//   }));

//   return (
//     <div className={styles.formWrapper}>
//       <div className={styles.inputGroup}>
//         <Input
//           label="Название"
//           name="name"
//           smallText="По умолчанию название присваивается автоматически: asst-F893AEZdpOyWFRNn9Ug"
//           value={newAssistant ? newAssistant.name : "Название ассистента"}
//           onChange={handlerNameAssistant}
//           placeholder={"Введите название"}
//         />
//         <Input
//           label="Имя"
//           name="firstName"
//           smallText="Это имя будет использоваться в шаблоне инструкции. При общении ассистент будет представляться им и работать под этим именем"
//           value={newAssistant ? newAssistant.firstName : "Имя ассистента"}
//           onChange={handlerFirstNameAssistant}
//           placeholder={"Введите имя"}
//         />
//       </div>

//       <Textarea
//         placeholder="Описание компании"
//         value={newAssistant ? newAssistant.companyDescription : ""}
//         onChange={handlerCompanyDescription}
//         label={"Описание компании"}
//         smallText="Укажите информацию о компании: чем она занимается, как называется, какие услуги или продукты предоставляет. Это описание поможет ассистенту лучше понимать контекст и отвечать более точно"
//         name="companyDescription"
//       />

//       <div className={styles.selectContainer}>
//         <p className={styles.title}>Шаблон инструкции</p>
//         <Select
//           options={options}
//           onChange={handleSelectTemplate}
//           value={selectedTemplate}
//         />
//         <small>
//           Здесь вы можете выбрать шаблон для системной инструкции ассистента.
//           При необходимости вы можете просмотреть и изменить его в разделе
//           “Настройки → Расширенные настройки”, однако рекомендуем вносить
//           изменения только если вы точно понимаете, как это повлияет на работу
//           ассистента.
//         </small>
//       </div>
//     </div>
//   );
// };

import React, { useEffect, useRef } from "react";
import { Input } from "../../components/Input/Input";
import { Textarea } from "../../components/Textarea/Textarea";
import { useDispatch, useSelector } from "react-redux";
import {
  setNewAssistant,
  setUpdateAssistant,
} from "../../../../store/slices/assistantSlice";
import styles from "./AssistantFormModule.module.scss";
import { Select } from "../../ui/Select/Select";

// Improved helper function to replace template variables with actual values
const replaceTemplateVariables = (template, assistant) => {
  if (!template) return "";

  // Create a regex to find all ${variable} patterns
  const variableRegex = /\${([^}]+)}/g;

  return template.replace(variableRegex, (match, variableName) => {
    // Check if the variable exists directly in the assistant object
    if (assistant && assistant[variableName] !== undefined) {
      return assistant[variableName];
    } else if (variableName.includes(".")) {
      // Handle nested properties like "settings.something"
      const parts = variableName.split(".");
      let value = assistant;

      for (const part of parts) {
        if (!value || value[part] === undefined) return match; // Early return if path doesn't exist
        value = value[part];
      }

      return value !== undefined ? value : match;
    }

    // Return the original placeholder if no value is found
    return match;
  });
};

export const AssistantFormModule = ({ newAssistant }) => {
  const dispatch = useDispatch();

  const prevAssistantRef = useRef();
  const prevSelectedTemplateRef = useRef();
  const forcedUpdateRef = useRef(false);

  const instructions = useSelector((state) => state?.instruction?.instructions);
  const updateAssistant = useSelector(
    (state) => state?.assistant?.updateAssistant
  );

  const selectedTemplate = newAssistant?.selectedTemplate || null;

  const logDebug = (message, data) => {
    if (process.env.NODE_ENV === "development") {
      console.log(`[AssistantFormModule] ${message}`, data);
    }
  };

  useEffect(() => {
    if (!selectedTemplate || !newAssistant) return;

    const templateChanged =
      selectedTemplate !== prevSelectedTemplateRef.current;
    const keyVariablesChanged = checkKeyVariablesChanged(
      prevAssistantRef.current,
      newAssistant
    );
    const forceUpdate = forcedUpdateRef.current;

    if (forcedUpdateRef.current) {
      forcedUpdateRef.current = false;
    }

    if (templateChanged || keyVariablesChanged || forceUpdate) {
      logDebug("Updating instruction due to changes", {
        templateChanged,
        keyVariablesChanged,
        forceUpdate,
      });

      const processedInstruction = replaceTemplateVariables(
        selectedTemplate,
        newAssistant
      );

      if (processedInstruction !== newAssistant.settings?.instruction) {
        logDebug("New processed instruction", processedInstruction);

        const updatedAssistant = {
          ...newAssistant,
          settings: {
            ...newAssistant.settings,
            instruction: processedInstruction,
          },
        };

        dispatch(setNewAssistant(updatedAssistant));
      }
    }

    prevAssistantRef.current = JSON.parse(JSON.stringify(newAssistant));
    prevSelectedTemplateRef.current = selectedTemplate;
  }, [selectedTemplate, newAssistant, dispatch]);

  const checkKeyVariablesChanged = (prev, current) => {
    if (!prev) return true;

    const directFields = [
      "name",
      "firstName",
      "companyName",
      "companyDescription",
    ];
    for (const field of directFields) {
      if (prev[field] !== current[field]) {
        logDebug(
          `Field ${field} changed from "${prev[field]}" to "${current[field]}"`
        );
        return true;
      }
    }

    if (prev.settings && current.settings) {
      const settingsFields = [
        "temperature",
        "maxLength",
        "useReminder",
        "grpcServicePort",
        "apiServicePort",
      ];
      for (const field of settingsFields) {
        if (prev.settings[field] !== current.settings[field]) {
          return true;
        }
      }
    } else if (prev.settings !== current.settings) {
      return true;
    }

    return false;
  };

  const handleSelectTemplate = (value) => {
    const updatedAssistant = {
      ...newAssistant,
      selectedTemplate: value,
    };

    forcedUpdateRef.current = true;

    dispatch(setNewAssistant(updatedAssistant));
  };

  const handlerNameAssistant = (value) => {
    if (newAssistant && !updateAssistant) {
      const updatedAssistant = {
        ...newAssistant,
        name: value,
      };
      dispatch(setNewAssistant(updatedAssistant));
    } else {
      const updatedAssistant = {
        ...updateAssistant,
        name: value,
      };
      dispatch(setUpdateAssistant(updatedAssistant));
    }
  };

  const handlerFirstNameAssistant = (value) => {
    const updatedAssistant = {
      ...newAssistant,
      firstName: value,
    };

    forcedUpdateRef.current = true;

    dispatch(setNewAssistant(updatedAssistant));
  };

  const handlerCompanyDescription = (e) => {
    const updatedAssistant = {
      ...newAssistant,
      companyDescription: e.target.value,
    };

    forcedUpdateRef.current = true;

    dispatch(setNewAssistant(updatedAssistant));
  };

  const handlerInstruction = (e) => {
    const updatedAssistant = {
      ...updateAssistant,
      settings: {
        ...updateAssistant.settings,
        instruction: e.target.value,
      },
    };

    dispatch(setUpdateAssistant(updatedAssistant));
  };

  const options =
    instructions?.map((item) => ({
      value: item.instruction,
      label: item.category,
    })) || [];

  console.log("object", newAssistant);

  return (
    <div className={styles.formWrapper}>
      {!updateAssistant && (
        <div className={styles.inputGroup}>
          <Input
            label="Название"
            name="name"
            smallText="По умолчанию название присваивается автоматически: asst-F893AEZdpOyWFRNn9Ug"
            value={newAssistant ? newAssistant.name : "Название ассистента"}
            onChange={handlerNameAssistant}
            placeholder={"Введите название"}
          />
          <Input
            label="Имя"
            name="firstName"
            smallText="Это имя будет использоваться в шаблоне инструкции. При общении ассистент будет представляться им и работать под этим именем"
            value={newAssistant ? newAssistant.firstName : "Имя ассистента"}
            onChange={handlerFirstNameAssistant}
            placeholder={"Введите имя"}
          />
        </div>
      )}

      {updateAssistant && (
        <Input
          label="Название"
          name="name"
          smallText="По умолчанию название присваивается автоматически: asst-F893AEZdpOyWFRNn9Ug"
          value={updateAssistant ? updateAssistant.name : "Название ассистента"}
          onChange={handlerNameAssistant}
          placeholder={"Введите название"}
        />
      )}

      {!updateAssistant ? (
        <Textarea
          placeholder="Описание компании"
          value={newAssistant ? newAssistant.companyDescription : ""}
          onChange={handlerCompanyDescription}
          label={"Описание компании"}
          smallText="Укажите информацию о компании: чем она занимается, как называется, какие услуги или продукты предоставляет. Это описание поможет ассистенту лучше понимать контекст и отвечать более точно"
          name="companyDescription"
        />
      ) : (
        <Textarea
          placeholder="Инструкция"
          value={updateAssistant ? updateAssistant?.settings?.instruction : ""}
          onChange={handlerInstruction}
          label={"Инструкция"}
          name="instruction"
        />
      )}

      {!updateAssistant && (
        <div className={styles.selectContainer}>
          <p className={styles.title}>Шаблон инструкции</p>
          <Select
            options={options}
            onChange={handleSelectTemplate}
            value={selectedTemplate}
          />
          <small>
            Здесь вы можете выбрать шаблон для системной инструкции ассистента.
            При необходимости вы можете просмотреть и изменить его в разделе
            "Настройки → Расширенные настройки", однако рекомендуем вносить
            изменения только если вы точно понимаете, как это повлияет на работу
            ассистента.
          </small>
        </div>
      )}
    </div>
  );
};
